<div id="loginBox">
	<form (ngSubmit)="onSubmit()">
		<div class="alert alert-danger" role="alert" *ngIf="formError">
			{{ formError }}
		</div>
		<div class="mb-3">
			<label for="inputEmail1">Adres E-mail</label>
			<input type="email" class="form-control" id="inputEmail1" name="email" [(ngModel)]="data.email" required />
		</div>
		<div class="mb-3">
			<label for="inputPassword1">Hasło</label>
			<input
				type="password"
				class="form-control"
				id="inputPassword1"
				name="password"
				[(ngModel)]="data.password"
				required
			/>
		</div>
		<button type="submit" class="btn btn-primary">Zaloguj</button>
		&nbsp;
		<a [href]="url" target="_blank" class="btn btn-secondary">Przypomnij hasło</a>
	</form>
</div>
